import React from 'react';

// CB:BEGIN email-preview-report-ready
const EmailReportReady: React.FC = () => {
  const address = '123 Rosewood Way, O\'Fallon, MO 63366';
  const link = 'https://corebids.com/reports/latest';
  return (
    <div style={{ fontFamily: 'Arial, sans-serif', maxWidth: '600px', margin: '0 auto', padding: 20 }}>
      <div style={{ background: '#10b981', padding: 20, borderRadius: 8, marginBottom: 20, textAlign: 'center' }}>
        <h2 style={{ color: 'white', margin: 0 }}>🎉 Your Roof Report is Ready!</h2>
      </div>
      <p style={{ fontSize: 16, lineHeight: 1.6, color: '#374151' }}>
        Excellent! Your comprehensive roof report for your property at <strong>{address}</strong> is now available and ready for review.
      </p>
      <div style={{ textAlign: 'center', margin: '30px 0' }}>
        <a href={link} style={{ background: '#2563eb', color: 'white', padding: '15px 30px', textDecoration: 'none', borderRadius: 8, fontWeight: 600, fontSize: 16, display: 'inline-block' }}>
          📋 Login to view your report
        </a>
      </div>
      <p style={{ fontSize: 16, lineHeight: 1.6, color: '#374151' }}><strong>What you'll find in your report:</strong></p>
      <ul style={{ fontSize: 16, lineHeight: 1.6, color: '#374151' }}>
        <li>Detailed roof measurements and square footage</li>
        <li>Roof pitch and complexity analysis</li>
        <li>Material recommendations and cost estimates</li>
        <li>Professional contractor matching</li>
      </ul>
      <p style={{ fontSize: 16, lineHeight: 1.6, color: '#374151' }}>
        Once you've reviewed your report, you can start receiving competitive bids from our network of qualified contractors.
      </p>
      <hr style={{ border: 'none', borderTop: '1px solid #e2e8f0', margin: '30px 0' }} />
      <p style={{ fontSize: 12, color: '#6b7280', textAlign: 'center' }}>
        From: CoreBids Notifications &lt;notifications@corebids.com&gt;<br />
        This mailbox isn't monitored. Please don't reply. Contact support via your dashboard.
      </p>
    </div>
  );
};

export default EmailReportReady;
// CB:END email-preview-report-ready


